/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAssetByIdOptions,
  GetAssetByIdStatus200,
  GetAssetByIdStatus400,
  GetAssetByIdStatus404,
} from '../types/GetAssetById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAssetById } from '../clients/getAssetById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAssetByIdQueryKey = ({ path }: Omit<GetAssetByIdOptions, 'headers'>) =>
  [{ url: '/v1/assets/:asset_id', params: path }] as const

type GetAssetByIdQueryKey = ReturnType<typeof getAssetByIdQueryKey>

export function getAssetByIdQueryOptions(
  { path }: GetAssetByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAssetByIdQueryKey({ path })
  return queryOptions<
    GetAssetByIdStatus200,
    ResponseErrorConfig<GetAssetByIdStatus400 | GetAssetByIdStatus404>,
    GetAssetByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAssetById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get asset by ID
 * {@link /v1/assets/:asset_id}
 */
export function useGetAssetById<
  TData = GetAssetByIdStatus200,
  TQueryData = GetAssetByIdStatus200,
  TQueryKey extends QueryKey = GetAssetByIdQueryKey,
>(
  { path }: { path: GetAssetByIdOptions['path'] | (() => GetAssetByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAssetByIdStatus200,
        ResponseErrorConfig<GetAssetByIdStatus400 | GetAssetByIdStatus404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getAssetByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getAssetByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAssetByIdStatus400 | GetAssetByIdStatus404>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
